var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('home-header'),_vm._v(" "),_c('div',{staticClass:"content page-width"},[_c('personal-center'),_vm._v(" "),_c('div',{staticClass:"margin-top-30"}),_vm._v(" "),_c('DefenseRoomList')],1),_vm._v(" "),_c('Foot')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5f9fd3f5","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/defenseOnline/Index.vue
// module id = null
// module chunks = 